import type { ReactNode } from 'react';

/**
 * Rich-text renderer for react-intl `<b>` tags in translated messages.
 * @param chunks Content wrapped by the `<b>` tag in the message.
 * @returns The content rendered in bold.
 */
export function renderBold(chunks: ReactNode[]): ReactNode {
  return <b>{chunks}</b>;
}
